import React from "react"
import PropTypes from "prop-types"
import classNames from 'classnames'
import dynamic from "next/dynamic"
const Card = dynamic(() => import("../Card/Card"))
import { getCdnImage } from '../../adapters/cloudinary.adapters'
const CardContent = dynamic(() => import("../Card/CardContent"))
const CardActions = dynamic(() => import("../Card/CardActions"))
const Button = dynamic(() => import("../Button/Button"))
const Typography = dynamic(() => import("../Product/Typography/Typography"))
const ImageSet = dynamic(() => import("../ImageSet"))
import LazyLoad from 'react-lazyload'
import styles from "../../styles/components/ProductList/ProductList-tw-styles"
import { sanitize } from "../../helpers/sanitizationHelper"
import { bestSellerText, exclusive, learnMore } from "../../constants/index"
import { withRouter } from "next/router"
class ProductListCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false
        }
    }

    render() {
        const { router,data } = this.props
        const { cardStyle, titleStyle, backgroundImage, textWrapper, imgWrapper, plpWrapper, linkStyle, plpImg, buynowwrapper, bestSellerTagWrapper, bestSellerTagWrapperNew, bestSellerTag, buyNowButton } = styles.plpCard
        const productShortName = sanitize(data.productName, true)/* ideally should be short name but presently snaitized full name*/
        
        return (
            <React.Fragment>
                <LazyLoad height={'200px'} once offset={100}>
                    <Card className={cardStyle}>
                        <div className={data.exclusiveImage ? bestSellerTagWrapperNew : bestSellerTagWrapper}>
                            {data.bestSellerProduct &&
                                <Typography component='div' className={bestSellerTag}>{bestSellerText}</Typography>
                            }
                            {data.productShowExclusiveText ? <Typography component='div' className={bestSellerTag}>{exclusive}</Typography> : null}
                            {data.exclusiveImage && <img className='float-left h-20' src={getCdnImage(data.exclusiveImage.image.url, { w: 400 })} alt={data.exclusiveImage.altText} />}
                        </div>
                        <CardContent className={plpImg}>
                            <a href={data.externalLink ? data.externalLink : data.slug} className={`${linkStyle}` + ' ' + `${(data.bestsellerCarosuelGaClass) ? data.bestsellerCarosuelGaClass : 'event_view_more_details'}`} data-action-detail={(data && data.productCategoryGaLabel) ? `${data.productCategoryGaLabel}_click` : `${productShortName}_click`}
                                target={data.externalLink ? '_blank' : '_self'} rel='noreferrer' aria-label={data?.heroImage.altText}>
                                <div className={imgWrapper}>
                                    <div className={classNames(backgroundImage, `bg-${data.listingCardBackgroundColour && data.listingCardBackgroundColour.toLowerCase()}`)}>
                                        <ImageSet content={data.heroImage} lazyload={true} isAriaHidden={true}/>
                                        {/* <img alt={data.productName} src={isMobile ? getImageUrl(data.heroImage.smartphoneImage.url) : getImageUrl(data.heroImage.desktopImage.url)} /> */}
                                    </div>
                                </div>
                                {/* <div className={textWrapper}>
                                    {data.productName && (
                                        <a href={data.externalLink ? data.externalLink : data.slug} className={`${linkStyle}` + ' ' + `${(data.bestsellerCarosuelGaClass) ? data.bestsellerCarosuelGaClass : 'event_view_more_details'}`} data-action-detail={`${(data.productCategoryGaLabel) ? `${data.productCategoryGaLabel}_click` : `${productShortName}`}_click`} target={data.externalLink ? '_blank' : '_self'} rel='noreferrer' >
                                            <Typography component='h2' className={titleStyle}>{data.productName}</Typography>
                                        </a>
                                    )}
                            </div> */}
                                <div className={textWrapper}>
                                    {data.productName && (
                                        <Typography component='h2' className={titleStyle}>{data.productName}</Typography>
                                    )}
                                </div>
                            </a>
                        </CardContent>
                        <div className={plpWrapper}>  
                            <CardActions className={buynowwrapper}>
                                {data && <div className={buyNowButton}>
                                    <Button onClick={()=>router.push(`${data.slug}`)}
                                        className='primary-default-plp'
                                        gaClass='event_buy_now'
                                        target='_self'
                                        aria-label={productShortName}
                                        data-action-detail={`${(data.productCategoryGaLabel) ? data.productCategoryGaLabel : productShortName + `_Buy`}`}
                                    > {learnMore}
                                    </Button>
                                </div>}
                            </CardActions>
                        </div>
                    </Card>
                </LazyLoad>
            </React.Fragment>
        )
    }
}

ProductListCard.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
    storeLocatorData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    cardIndex: PropTypes.number,
    isMobile: PropTypes.bool,
    length: PropTypes.number,
    router: PropTypes.instanceOf(Object)
}

export default withRouter(ProductListCard)
